import React from "react";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { Link } from "@mui/material";

export const ExpandableCell: React.FC<GridRenderCellParams & { minLength?: number }> = ({ value = '', minLength = 150 }) => {
    const [expanded, setExpanded] = React.useState(false);
  
    return (
      <div>
        {expanded ? value : value.slice(0, minLength)}&nbsp;
        {value.length > minLength && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link
            type="button"
            component="button"
            sx={{ fontSize: 'inherit', letterSpacing: 'inherit' }}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? 'show less' : 'show more'}
          </Link>
        )}
      </div>
    );
}